import { TableCell } from "@mui/material";
import React from "react";

const OptimizedTableCell = ({ children, sx }: { children: string | number; sx: any }) => {
    return <TableCell sx={sx}>{children}</TableCell>;
};

function areEqualCells(prev: { children: string | number }, next: { children: string | number }) {
    return prev.children === next.children;
}
export default React.memo(OptimizedTableCell, areEqualCells);
